/* Scroll-to-buy-box — shared by every section whose CTA jumps to the PDP form.

   The CTA keeps href="#trinsic-product-form" so it degrades to a native anchor
   jump with JS off, and so a CTA sitting on a non-PDP page (where the id never
   renders) still follows its href instead of dying under a swallowed click.
   preventDefault therefore fires ONLY once a target has actually been found.

   Bound once on the document rather than per-CTA: delegation covers sections
   the theme editor re-renders after load, so there is no shopify:section:load
   re-init to keep in sync. The dataset flag guards the one case delegation
   can't — the module being evaluated twice on one page. */
(function () {
  var HOOK = '[data-trinsic-scroll-to-form]';
  var TARGET_ID = 'trinsic-product-form';
  var FALLBACK = 'form[action*="/cart/add"]';
  var INIT = 'trinsicScrollToFormInited';

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  /* The buy-box wrapper is the intended landing point; the add-to-cart form is
     the fallback for templates that render a buy box without the id. */
  function findTarget() {
    return document.getElementById(TARGET_ID) || document.querySelector(FALLBACK);
  }

  function onClick(event) {
    if (event.defaultPrevented) return;
    /* Let the browser own modified clicks — new tab / new window still work. */
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest ? event.target.closest(HOOK) : null;
    if (!link) return;

    var target = findTarget();
    if (!target) return; /* off-PDP: fall through to the href */

    event.preventDefault();
    target.scrollIntoView({
      behavior: reduceMotion && reduceMotion.matches ? 'auto' : 'smooth',
      block: 'start',
    });
  }

  if (document.documentElement.dataset[INIT] === 'true') return;
  document.documentElement.dataset[INIT] = 'true';

  document.addEventListener('click', onClick);
})();
